<template>
  <div
    class="auth-brand-panel-slide"
    :class="{ 'auth-brand-panel-slide--active': active }"
    :aria-hidden="active ? 'false' : 'true'"
    :data-testid="`auth-brand-panel-slide--${slide.id}`"
  >
    <iframe
      v-if="slide.iframeSrc"
      class="auth-brand-panel-slide__iframe"
      :src="slide.iframeSrc"
      :sandbox="AUTH_BRAND_PANEL_IFRAME_SANDBOX"
      :title="slide.heading || 'Brand visual'"
      :tabindex="active ? 0 : -1"
      :data-testid="`auth-brand-panel-slide__iframe--${slide.id}`"
    />
    <template v-else>
      <img
        class="auth-brand-panel-slide__bg"
        :src="slide.backgroundSrc"
        alt=""
        aria-hidden="true"
      />
      <div class="auth-brand-panel-slide__copy">
        <h2
          v-if="slide.heading"
          class="auth-brand-panel-slide__heading"
          :data-testid="`auth-brand-panel-slide__heading--${slide.id}`"
        >
          {{ slide.heading }}
        </h2>
        <p
          v-if="slide.subhead"
          class="auth-brand-panel-slide__subhead"
          :data-testid="`auth-brand-panel-slide__subhead--${slide.id}`"
        >
          {{ slide.subhead }}
        </p>
        <a
          v-if="slide.cta && slide.ctaHref"
          class="auth-brand-panel-slide__cta"
          :href="slide.ctaHref"
          target="_blank"
          rel="noopener noreferrer"
          :tabindex="active ? 0 : -1"
          :data-testid="`auth-brand-panel-slide__cta--${slide.id}`"
        >
          {{ slide.cta }}
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import { AUTH_BRAND_PANEL_IFRAME_SANDBOX } from './AuthBrandPanelUtils';

export default {
  name: 'AuthBrandPanelSlide',
  props: {
    slide: { type: Object, required: true },
    active: { type: Boolean, default: false },
  },
  data() {
    return {
      AUTH_BRAND_PANEL_IFRAME_SANDBOX,
    };
  },
};
</script>

<style lang="scss" scoped>
@import './AuthBrandPanelSlide.scss';
</style>
